import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@lib/services/auth-service.service';

export const AuthGuard: CanActivateFn = () => {
  if (inject(AuthService).isInitLogin()) {
    inject(Router).navigate(['/init']);
  } else if (!inject(AuthService).isAuthenticated()) {
    inject(Router).navigate(['/unauthorized']);
  }
  return true;
};

// should not display init page if already logged in
export const InitGuard: CanActivateFn = () => {
  if (!inject(AuthService).isInitLogin()) {
    inject(Router).navigate(['']);
  }
  return true;
};
